// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5e86f910] .mandatory .v-label.v-label--active:after, .mandatory .v-label[data-v-5e86f910]:after {\n        margin-left: 3px;\n}", ""]);
// Exports
module.exports = exports;
